import { Injectable } from '@angular/core';
import { ApiConfigService } from '../../../shared-services/api-config.service';
import { Meeting } from '../../../dtos/meeting';
import { Observable } from 'rxjs/Observable';
import { SubscriptionPacketDto } from '../../../dtos/subscriptionPacketDto';

@Injectable({
    providedIn: 'root'
})
export class MeetingService {

    constructor(private apiConfigService: ApiConfigService) {
    }

    checkMeetingCode(code: string):Observable<Meeting> {
        return this.apiConfigService.get<Meeting>('api/meeting/join/waiting/'+code);
    }

    joinedMeetingCode(code: string):Observable<Meeting> {
        return this.apiConfigService.get<Meeting>('api/meeting/join/room/'+code);
    }

    startMeeting(code: string){
        return this.apiConfigService.get<Meeting>('api/meeting/start/room/'+code);
    }

    guideLoggedOut(code: string){
        return this.apiConfigService.get<Meeting>('api/meeting/logout/room/'+code);
    }
}
